module.exports = __webpack_public_path__ + "static/media/icon_user_white.cac26e47.png";